import { defineMutator } from '@rocicorp/zero';
import { uuidv7 } from 'uuidv7';
import * as z from 'zod';
import { assertCan } from '../utils.js';
export const AddLocationSchema = z.object({
    name: z.string(),
    code: z.string(),
});
export const locations = {
    add: defineMutator(AddLocationSchema, async ({ tx, ctx, args: location }) => {
        assertCan(ctx, 'organisation.manage');
        await tx.mutate.locations.insert({
            id: uuidv7(),
            name: location.name,
            code: location.code,
            createdAt: new Date().getTime(),
        });
    }),
};
//# sourceMappingURL=location.mutators.js.map